import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { Box, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import { useMutation, useQuery } from 'react-query';
import IconButton from '../../../components/IconButton';
import { ICON_BUTTON_TYPE } from '../../../constants';
import { deleteDoctorApi, getDoctorApi } from '../../../utils/api';
import AddDoctorModal from './AddDoctorModal';
import TopBar from './TopBar';

const DoctorContact = ({ user, recipient }) => {
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [activeEditData, setActiveEditData] = React.useState(null);

  const { data, isLoading, refetch } = useQuery(
    ['getDoctorApi'],
    () => getDoctorApi({ userId: user?._id, recipientId: recipient?._id }),
    {
      retry: false,
      cacheTime: 0,
    },
  );

  const deleteDoctorHandler = useMutation(deleteDoctorApi, {
    onSuccess: async ({ data }) => {
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleDelete = (item) => {
    deleteDoctorHandler.mutate({ userId: user?._id, recipientId: recipient?._id, doctorId: item?._id });
  };

  const handleShowEdit = (item) => {
    setActiveEditData(item);
    setShowAddModal(true);
  };

  return (
    <Grid>
      <TopBar
        btnText="Add a Doctor"
        onClick={() => {
          setShowAddModal(true);
          setActiveEditData(null);
        }}
      />

      {isLoading && (
        <Grid marginY={10} container justifyContent={'center'}>
          <CircularProgress size={40} />
        </Grid>
      )}

      {!isLoading && isEmpty(data?.data) && (
        <Typography variant="h5" textAlign="center">
          No Doctor found!
        </Typography>
      )}

      {!isLoading &&
        !isEmpty(data?.data) &&
        data?.data.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              p: 4,
              bgcolor: 'background.paper',
              borderRadius: 2,
              mt: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    bgcolor: '#e6f2f0',
                    borderRadius: '50%',
                  }}
                >
                  <LocalHospitalIcon sx={{ color: '#26796b', fontSize: 20 }} />
                </Box>
                <Typography variant="h6" color="text.primary">
                  {item?.name}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <IconButton type={ICON_BUTTON_TYPE.edit} onClick={() => handleShowEdit(item)} />
                <IconButton type={ICON_BUTTON_TYPE.delete} onClick={() => handleDelete(item)} />
              </Box>
            </Box>
            <Divider />
            <Grid container spacing={5}>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Phone number
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {item?.phoneNo}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Clinic
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {item?.clinic}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Address
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {item?.address}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Available
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {item?.availability}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        ))}
      <AddDoctorModal
        show={showAddModal}
        onClose={() => {
          setShowAddModal(false);
          setActiveEditData(null);
        }}
        recipient={recipient}
        refetch={refetch}
        activeEditData={activeEditData}
      />
    </Grid>
  );
};

export default DoctorContact;
